import { useState, useEffect } from 'react';
import { apiService } from '../../../api/apiService';
import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";


const useFunctionOptions = (level: string, value: string) => {
   const { instance } = useMsal();
  const management = encodeURIComponent(localStorage.getItem('management') || '');

  const [options, setOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      try {
        const result = await apiService(
          `/static_functions?level=${encodeURIComponent(level)}&value=${encodeURIComponent(value)}&management=${management}`,
          'GET',
          undefined,
          undefined,
          instance as PublicClientApplication
        );
        if (result.status === 'success') {
          setOptions(result.data || []);
        } else {
          console.error(`Unexpected response structure for ${level}:`, result);
          setOptions([]);
        }
      } catch (error) {
        console.error(`Error fetching ${level} options:`, error);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    if (value || level === 'l1') {
      fetchOptions();
    } else {
      setOptions([]); // Reset options if no value is provided
    }
  }, [level, value, management]);

  return { options, loading };
};

export default useFunctionOptions;